import Observer from "@viz-ui/services/observer/observer";
import NamespacedObserver from "@viz-ui/services/observer/namespacedObserver";

angular
  .module("acl.visualizer.observer", [])
  .service("Observer", () => Observer)
  .service("NamespacedObserver", () => NamespacedObserver);
